import { render, staticRenderFns } from "./StrokeTopBottomIcon.vue?vue&type=template&id=78839450&"
import script from "./StrokeTopBottomIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeTopBottomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports